/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createFileResponseFromDiscriminatorValue, createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, type FileResponse, type HttpValidationProblemDetails, type IError } from '../../models/index.js';
// @ts-ignore
import { ArchiveRequestBuilderRequestsMetadata, type ArchiveRequestBuilder } from './archive/index.js';
// @ts-ignore
import { CopyRequestBuilderRequestsMetadata, type CopyRequestBuilder } from './copy/index.js';
// @ts-ignore
import { DownloadRequestBuilderRequestsMetadata, type DownloadRequestBuilder } from './download/index.js';
// @ts-ignore
import { MoveRequestBuilderRequestsMetadata, type MoveRequestBuilder } from './move/index.js';
// @ts-ignore
import { PreviewsRequestBuilderRequestsMetadata, type PreviewsRequestBuilder } from './previews/index.js';
// @ts-ignore
import { RestoreRequestBuilderRequestsMetadata, type RestoreRequestBuilder } from './restore/index.js';
// @ts-ignore
import { RevisionsRequestBuilderNavigationMetadata, RevisionsRequestBuilderRequestsMetadata, type RevisionsRequestBuilder } from './revisions/index.js';
// @ts-ignore
import { SharesRequestBuilderNavigationMetadata, SharesRequestBuilderRequestsMetadata, type SharesRequestBuilder } from './shares/index.js';
// @ts-ignore
import { TagsRequestBuilderNavigationMetadata, TagsRequestBuilderRequestsMetadata, type TagsRequestBuilder } from './tags/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/{file-id}
 */
export interface FileItemRequestBuilder extends BaseRequestBuilder<FileItemRequestBuilder> {
    /**
     * The archive property
     */
    get archive(): ArchiveRequestBuilder;
    /**
     * The copy property
     */
    get copy(): CopyRequestBuilder;
    /**
     * The download property
     */
    get download(): DownloadRequestBuilder;
    /**
     * The move property
     */
    get move(): MoveRequestBuilder;
    /**
     * The previews property
     */
    get previews(): PreviewsRequestBuilder;
    /**
     * The restore property
     */
    get restore(): RestoreRequestBuilder;
    /**
     * The revisions property
     */
    get revisions(): RevisionsRequestBuilder;
    /**
     * The shares property
     */
    get shares(): SharesRequestBuilder;
    /**
     * The tags property
     */
    get tags(): TagsRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FileResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<FileResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const FileItemRequestBuilderUriTemplate = "{+baseurl}/files/{file%2Did}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const FileItemRequestBuilderNavigationMetadata: Record<Exclude<keyof FileItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    archive: {
        requestsMetadata: ArchiveRequestBuilderRequestsMetadata,
    },
    copy: {
        requestsMetadata: CopyRequestBuilderRequestsMetadata,
    },
    download: {
        requestsMetadata: DownloadRequestBuilderRequestsMetadata,
    },
    move: {
        requestsMetadata: MoveRequestBuilderRequestsMetadata,
    },
    previews: {
        requestsMetadata: PreviewsRequestBuilderRequestsMetadata,
    },
    restore: {
        requestsMetadata: RestoreRequestBuilderRequestsMetadata,
    },
    revisions: {
        requestsMetadata: RevisionsRequestBuilderRequestsMetadata,
        navigationMetadata: RevisionsRequestBuilderNavigationMetadata,
    },
    shares: {
        requestsMetadata: SharesRequestBuilderRequestsMetadata,
        navigationMetadata: SharesRequestBuilderNavigationMetadata,
    },
    tags: {
        requestsMetadata: TagsRequestBuilderRequestsMetadata,
        navigationMetadata: TagsRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const FileItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: FileItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, application/problem+json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
    get: {
        uriTemplate: FileItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFileResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
